<div class="fallback__container">
  <div class="fallback__img">
    <img [src]="img" alt="img" />
  </div>
  <div class="fallback__text__items">
    <div class="fallback__text">
      <h3 class="fallback__text__title">{{ title }}</h3>
      <p class="fallback__text__subtitle">{{ message }}</p>
    </div>
    <div class="fallback__text__action">
      <button aria-label="Go to Home Page" class="btn__primary" routerLink="/">
        {{ "fallback.goToHomePage" | translate }}
      </button>
    </div>
  </div>
</div>
